import { DriveOnDisplayableTaskDto as DriveonTask } from '@/generated/model';
import { useTranslation } from 'react-i18next';
import { getTaskAddress } from '@/components/common/TaskHelper';

type DisplayTaskProps = {
  task: DriveonTask;
  checkIfEmpty(label: string | undefined | 0): string;
};

export function DisplayTask({ task, checkIfEmpty }: DisplayTaskProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div>{t('menetlevel.displaytask.name')}:</div>
      <div>
        <b>{checkIfEmpty(task.taskName)}</b>
      </div>
      {/*<div>{t('menetlevel.displaytask.teamname')}: {task.teamName}</div>*/}
      <div> {t('menetlevel.displaytask.eventuslocation')}:</div>
      <div>
        <b>{checkIfEmpty(getTaskAddress(task))}</b>
      </div>
      <br />
      <div>
        {t('menetlevel.displaytask.status')}: {checkIfEmpty(task.eventusStatus)}
      </div>
      <div>ICP: {checkIfEmpty(task.orderNumber)}</div>
      <div>PG5: {checkIfEmpty(task.pg5ReferenceNumber)}</div>
    </div>
  );
}
